/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingBatchResponse {
    getFixupPrototypeFunction() { return AwsSecurityHubFindingBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingBatchResponse>): AwsSecurityHubFindingBatchResponse {
        let obj = Object.assign(new AwsSecurityHubFindingBatchResponse(), model);
        AwsSecurityHubFindingBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingBatchResponse>): AwsSecurityHubFindingBatchResponse {
        if (!model) return null;
        return AwsSecurityHubFindingBatchResponse.newInstance(<AwsSecurityHubFindingBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingBatchResponse) {
        if (!obj) return;

        models.AwsSecurityHubFindingBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingBatchResponse): boolean {
        Object.setPrototypeOf(obj, AwsSecurityHubFindingBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.AwsSecurityHubFinding.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.AwsSecurityHubFinding; };

}
